import React, { useEffect, useState } from "react";
import LoginForm from "../../components/login/LoginForm.Component";
import { useLocation, useNavigate } from "react-router-dom";
import { getLauncherLink, getMaintenanceurl } from "../../utils/helpter";
import BusIcon from "../../assets/BusIcon";
import CargoIcon from "../../assets/CargoIcon";
import SettingIcon from "../../assets/SettingIcon";
import { getRedirectUrl } from "../../utils/helpter";
import OTPModal from "../form-components/OTPModal";
import http from '../../utils/_httpServices';
import AlertModal from "../form-components/AlertModal";


export const Entry = () => {
    const [formType, setFormType] = useState("login");
    const [loginFor, setLoginFor] = useState('B')
    const location = useLocation();
    const navigate = useNavigate();
    const [macAddress, setMacAddress] = useState('')
    const labList = [
        { name: 'Bus', value: 'B', icon: <BusIcon /> },
        { name: 'Cargo', value: 'C', icon: <CargoIcon /> },
        { name: 'Maintenance', value: 'M', icon: <SettingIcon /> },
    ]
    const [openModal, setOpenModal] = useState({
        id: 0,
        open: false,
        data: {},
    })

    const [showAlert, setShowAlert] = useState({
        open: false,
        msg: ''
    })
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const xValue = searchParams.get("X");
        if (xValue) {
            const values = xValue.split('^');
            if (values?.length > 0) {
                sessionStorage.setItem("X", values[0]);
                setMacAddress(values[1])
            }
        }
    }, [location.search]);

    useEffect(() => {
        if (window.location.pathname.toLocaleLowerCase().includes("/cargo")) {
            setLoginFor("C")
        } else {
            setLoginFor('B')
        }
    }, []);

    const handleModal = (id = 0, open = false, data = {}) => {
        setOpenModal((prev) => ({
            ...prev,
            id: id,
            open: open,
            data,
        }))
    }

    const handleOPTLogin = (value) => {
        const body = {
            ODP: 0,
            Code: value?.code,
            LoginID: value?.username,
            Password: value?.password
        }
        http.HttpCall('/LoginV2/LoginV3', 'Post', {}, body).then((response) => {
            if (response.status === 200 && response.data.Status === "true") {
                if (response?.data?.Data?.WebCRSEnableRole === 0 && response?.data?.Data?.WebCRSEnabledMode === 0) {
                    setShowAlert((prev) => ({
                        open: true,
                        msg: 'Web is not enabled for this company'
                    }))
                } else {
                    if (response?.data?.Data?.IsOdpLogin === 1) {
                        handleModal(1, true, { ...value, MobileNo: response?.data?.Data?.MobileNo })
                    } else {
                        window.location.replace(getRedirectUrl(value));
                        return false;
                    }
                }
            } else {
                setShowAlert((prev) => ({
                    open: true,
                    msg: response.data.ErrMessage || ''
                }))
            }
        })
    }
    const handleCargoLogin = (value) => {
        const body = {
            ODP: 0,
            Code: value?.code,
            LoginID: value?.username,
            Password: value?.password,
            GUID: '',
        }
        http.HttpCall('/LoginODP/LoginVarify', 'Post', {}, body, "AmxsG7zkJB").then((response) => {
            if (response.status !== 200 || response.data.Status !== "true") {
                throw new Error(response?.data?.ErrMessage || 'Request Failed')
            }
            if (response.data.Data.IsOdpLogin === 1) {
                handleModal(1, true, { ...value, MobileNo: response?.data?.Data?.MobileNo })
            } else {
                window.location.replace(getRedirectUrl(value));
            }
        }).catch((e) => {
            setShowAlert((prev) => ({
                open: true,
                msg: e.message
            }))
        })
    }
    const handleOnSubmit = (value) => {
        if (loginFor === 'B') {
            handleOPTLogin({ ...value, loginFor })
        } else if (loginFor === 'C') {
            handleCargoLogin({ ...value, loginFor })
        } else {
            window.location.replace(getRedirectUrl({ ...value, loginFor }));
            return false;
        }
    }
    return (
        <>
            <div className="container login-page">
                <div className="left--part">
                    <div className="login--wrapper">
                        <div className="login-header">
                            <div className="logo-txt">
                                <div className='login--logo--wrapper'>
                                    <img key='company-logo' src="/maventech-logo.png" alt="Maventech Labs Pvt Ltd." />
                                </div>
                                <span className="head--txt">MavenConnect 2.0</span>
                            </div>
                            <nav class="menu-tabs">
                                {labList.map((obj) => (
                                    <div class={`tab ${loginFor === obj.value ? 'active' : ''}`}
                                        onClick={() => {
                                            if (obj.value === "B") {
                                                navigate("/bus");
                                            } else if (obj.value === 'C') {
                                                navigate("/cargo");
                                            } else if (obj.value === "M") {
                                                window.location.replace(getMaintenanceurl());
                                            }
                                            setLoginFor(obj.value)
                                        }}
                                    >
                                        {obj.icon}
                                        <div>
                                            {obj.name}
                                        </div>
                                    </div>
                                ))}
                            </nav>
                        </div>
                        {formType === 'login' ? <LoginForm handleOnSubmit={handleOnSubmit} /> : <></>}

                    </div>
                    <div className="bottom-section">
                        <div className="link-text">
                            {macAddress ? `( Mac Address: ${macAddress} )` : <a href={getLauncherLink()} target="_blank" rel="noreferrer">Download Security Environment Enabler (SEE)</a>}
                        </div>
                        <div className="bottom-text">
                            You agree to our <a href="/terms_of_use" target="_blank" rel="noreferrer">Terms of Use</a> agreement and <a target="_blank" rel="noreferrer" href="/privacy_policy">Privacy Policy</a>
                        </div>
                        <div className="helpline--wrapper"  >
                            MavenTech Labs Helpline 08065927752 (10:30 AM to 08:30 PM)
                        </div>
                        <div className="copy--right--txt"> &copy; {new Date().getFullYear()} Operated by Maventech Labs Private Limited.</div>
                    </div>

                </div>
                <div className='footer-image--wrapper'>
                    <img key='footer-image' src="/footerImage.png" alt="Maventech Labs Pvt Ltd." />
                </div>
            </div>
            {(openModal?.open && openModal.id === 1) &&
                <OTPModal data={openModal?.data || {}} onClose={() => {
                    handleModal()
                }} />
            }
            {showAlert?.open && <AlertModal msg={showAlert?.msg} onClose={() => {
                setShowAlert({
                    open: false,
                    msg: ''
                })
            }} />}
        </>
    );
};